// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"

Rails.start()
Turbolinks.start()
ActiveStorage.start()


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

global.toastr = require("toastr")
import "../stylesheets/application.scss"
import "../reports/price_catalog"
import "../inventory_documents"
import "../app_experience"

// jQuery global: NO se expone desde acá a propósito. `plugins.bundle.js` de
// Metronic (cargado al final del <body>, después de este pack) embebe su
// propia jQuery 3.4.1 y pisa `window.$`/`window.jQuery` de todos modos — el
// `require("jquery")` de este pack nunca ganaba la carrera, sólo duplicaba
// ~283 KB sin usarse. El `ProvidePlugin` de config/webpack/webpack.config.js
// sigue resolviendo `$`/`jQuery` para código propio que haga `import $ from
// 'jquery'` dentro de este pack.

// Habilita "Agregar a pantalla de inicio" también desde el layout de
// escritorio (Fase 6 del plan móvil) — no sólo desde el pack `mobile`.
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.register("/sw.js").catch(() => {})
}
